import AuthMiddleware from './AuthMiddleware'

export default AuthMiddleware
